import React from 'react';
import { BasePureTableAction, PureTableAction, PureTableRowElement, RemoveItemProps } from './PureTable.types';
import PureTable from './PureTable';
import styles from './PureTable.module.scss';
import { classes } from '../../../lib/utils/cssUtils';

export const getRemoveColumn = ({
  onBinClickHandler,
  itemsRemovingState,
  id,
  canRemove,
  titleKey,
  individual = true,
}: {
  id: string;
  canRemove: boolean;
  titleKey: PureTableAction;
  individual?: boolean;
} & RemoveItemProps): PureTableRowElement[] => {
  if (!onBinClickHandler) {
    return [];
  }

  if (!canRemove) {
    return [''];
  }

  return [
    !itemsRemovingState?.[id] ? (
      <PureTable.DeleteAction
        key={`delete-${id}`}
        id={id}
        titleKey={titleKey}
        onClick={onBinClickHandler}
        className={classes({ [styles.deleteInOneRow]: !individual })}
      />
    ) : (
      <PureTable.Loader key={`delete-loader-${id}`} className={classes({ [styles.deleteInOneRow]: !individual })} />
    ),
  ];
};

export const getBaseTableAction = (action: PureTableAction) => action.split('.')[0] as BasePureTableAction;
